import React, { useContext } from "react";

const GlobalContext = React.createContext();
export const useGlobalContext = () => useContext(GlobalContext);

export default GlobalContext;
